import checkIfUserHasAccess from "../components/common/UserCheckAccess";
import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";

const getLocalStorageItem = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);

    if (item === null) {
      // Item not found in localStorage
      return defaultValue;
    }

    try {
      return JSON.parse(item);
    } catch (parseError) {
      if (item === "true") return true;
      if (item === "false") return false;
      // Attempt to convert numeric strings to numbers
      if (!isNaN(Number(item)) && !isNaN(parseFloat(item))) return Number(item);

      return item;
    }
  } catch (error) {
    console.error(`Error accessing localStorage for key "${key}":`, error);
    return defaultValue;
  }
};

export const COMPANY_CODE = getLocalStorageItem("companyCode", "-");
export const API_PATHS = getLocalStorageItem("apiPaths", []);
export const COMPANY_PRIVATE_KEY = getLocalStorageItem("companyPrivateKey");
export const COMPANY_PUBLIC_KEY = getLocalStorageItem("companyPublicKey");
export const CURRENT_EDITING_LEADFORM = getLocalStorageItem(
  "currentEditingLeadForm",
);
export const CURRENT_EDITING_PRODUCT_LIST = getLocalStorageItem(
  "currentEdittingProductsList",
);
export const CURRENT_SELECTED_DEPARTMENT = getLocalStorageItem(
  "currentSelectedDepartment",
);
// console.log(
//   "Current selected department from constants",
//   CURRENT_SELECTED_DEPARTMENT,
// );
export const CURRENT_USER = getLocalStorageItem("currentUser");
export const CURRENT_USER_EMPLOYEE_ID = getLocalStorageItem(
  "currentUserEmployeeID",
);
export const CURRENT_USER_LOGIN_STATUS = getLocalStorageItem(
  "currentUserLoginStatus",
);
export const CURRENT_USER_NAME = getLocalStorageItem("currentUserName");
export const LOST_LEADS = getLocalStorageItem("lostLeads");
export const WON_LEADS = getLocalStorageItem("wonLeads");

const getImageUrl = (itemFilePath) => {
  if (!itemFilePath || typeof itemFilePath !== "string") return "";

  const normalizedPath = itemFilePath.replace(/\\/g, "/");
  const fileName = normalizedPath.split("/").pop();

  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : null;

  let IMAGE_BASE_URL = API_PATHS?.[0]?.IMG_API_PATH;

  if (!IMAGE_BASE_URL) return "";

  // Remove trailing slash from base URL if it exists
  const cleanBase = IMAGE_BASE_URL.replace(/\/+$/, "");

  // Construct URL without a global regex that breaks the protocol (http://)
  return `${cleanBase}/BONDTIME_PRODUCT_IMG/${fileName}`;
};
const ImageCellWithPreview = ({ value }) => {
  const imageUrl = getImageUrl(value);
  const [showPreview, setShowPreview] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const imgRef = useRef();

  const handleMouseEnter = (e) => {
    const rect = e.target.getBoundingClientRect();
    setCoords({
      x: rect.right + 16,
      y: rect.top,
    });
    setShowPreview(true);
  };
  const handleMouseLeave = () => {
    setShowPreview(false);
  };

  return (
    <>
      {imageUrl ? (
        <>
          <img
            ref={imgRef}
            src={imageUrl}
            alt="Product"
            style={{
              objectFit: "contain",
              width: "100%",
              height: "100%",
              cursor: "pointer",
              borderRadius: 6,
              boxShadow: showPreview ? "0 0 0 2px #2563eb" : undefined,
              transition: "box-shadow 0.2s",
            }}
            loading="lazy"
            onMouseEnter={handleMouseEnter}
            onMouseMove={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
          {showPreview &&
            imageUrl &&
            ReactDOM.createPortal(
              <div
                style={{
                  position: "fixed",
                  left: coords.x,
                  top: coords.y,
                  zIndex: 9999,
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                  padding: 8,
                  borderRadius: 8,
                  maxWidth: 350,
                  maxHeight: 350,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <img
                  src={imageUrl}
                  alt="Product Preview"
                  style={{
                    maxWidth: 320,
                    maxHeight: 320,
                    objectFit: "contain",
                    borderRadius: 6,
                  }}
                />
              </div>,
              document.body,
            )}
        </>
      ) : (
        <span style={{ fontSize: "0.75rem", color: "#9ca3af" }}>No Image</span>
      )}
    </>
  );
};

export function generateColumnsFromData(data) {
  if (!Array.isArray(data) || data.length === 0) return [];

  const columnWidths = {
    CUSTOMER: 200,
    ACTION: 200,
    product_description: 300,
    INV_DATE: 130,
    ENTERED_ON: 150,
    STATUS: 120,
  };

  const isDateKey = (key) =>
    key.toLowerCase().includes("date") ||
    key.toLowerCase().includes("_on") ||
    key.toLowerCase().endsWith("_dt");

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return Object.keys(data[0])
    .filter((key) =>
      key?.trim()?.toUpperCase()?.includes("COST")
        ? checkIfUserHasAccess("AC")
        : true,
    )
    .filter((key) =>
      key?.trim()?.toUpperCase()?.includes("PRICE")
        ? checkIfUserHasAccess("IN")
        : true,
    )
    .map((key) => {
      // const baseColumn = {
      //   field: key,
      //   headerName: key
      //     .replace(/_/g, " ")
      //     .replace(/\b\w/g, (c) => c.toUpperCase()),
      //   minWidth: columnWidths[key] || 100,
      //   flex: columnWidths[key] ? undefined : 1,
      //   resizable: true,
      //   type: typeof data[0][key] === "number" ? "number" : "string",
      // };
      const isDocumentNumberField =
        key.toLowerCase() === "inv" ||
        key.toLowerCase().includes("invno") ||
        key.toLowerCase().includes("invoice") ||
        key.toLowerCase().includes("do no") ||
        key.toLowerCase().includes("doc no") ||
        key.toLowerCase().includes("voucher no") ||
        key.toLowerCase().includes("slno") ||
        key.toLowerCase().includes("serial");

      const baseColumn = {
        field: key,
        headerName: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase()),
        minWidth: columnWidths[key] || 100,
        flex: columnWidths[key] ? undefined : 1,
        resizable: true,

        // Force document numbers as strings
        type: isDocumentNumberField
          ? "string"
          : typeof data[0][key] === "number"
            ? "number"
            : "string",
      };

      // Prevent comma formatting on document numbers
      if (isDocumentNumberField) {
        return {
          ...baseColumn,
          valueFormatter: (params) => {
            if (params?.value == null) return "";
            return String(params?.value).replace(/\.0$/, "");
          },
          renderCell: (params) => {
            const cleanValue = String(params?.value ?? "").replace(/\.0$/, "");

            // 2. Specific color injection if this exact field is INVNO
            if (key.toUpperCase() === "INVNO") {
              const cashcred = String(
                params.row?.cashcred || params.row?.CASHCRED || "",
              )
                .trim()
                .toUpperCase();
              const color = cashcred === "C" ? "#16a34a" : "#dc2626"; // Green for C, Red otherwise

              return (
                <div
                  style={{
                    color: color,
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  {cleanValue}
                </div>
              );
            }

            // Default string rendering for other generic document number fields
            return <span>{cleanValue}</span>;
          },
        };
      }

      if (isDateKey(key)) {
        return {
          ...baseColumn,
          renderCell: (params) => formatDate(params.value),
        };
      }

      // if (key.toUpperCase() === "INVNO") {
      //   return {
      //     ...baseColumn,
      //     renderCell: (params) => {
      //       const cashcred = String(params.row.cashcred || params.row.CASHCRED || "").trim().toUpperCase();
      //       const color = cashcred === "C" ? "#16a34a" : "#dc2626";
      //       return (
      //         <span style={{ color, fontWeight: 600, fontSize: "0.85rem" }}>
      //           {params.value}
      //         </span>
      //       );
      //     },
      //   };
      // }
      if (key === "STATUS") {
        return {
          ...baseColumn,
          renderCell: (params) => {
            const status = String(params.value || "")
              .trim()
              .toUpperCase();

            let label = "";
            let color = "";

            switch (status) {
              // CLOSED cases (same as Y)
              case "Y":
              case "CLOSED":
                label = "CLOSED";
                color = "#dc2626"; // red
                break;

              // PARTIAL cases
              case "P":
              case "PARTIAL":
                label = "PARTIAL";
                color = "#ca8a04"; // yellow
                break;
              case "RECEIVED":
              case "RECEIVED":
                label = "RECEIVED";
                color = "#16a34a";
                break;

              // OPEN cases (same as previous default)
              case "OPEN":
              default:
                label = "OPEN";
                color = "#16a34a"; // green
            }

            return (
              <div
                style={{
                  fontSize: "0.75rem",
                  fontWeight: "600",
                  color,
                }}
              >
                {label}
              </div>
            );
          },
        };
      }
      if (key.toUpperCase() === "IMAGEPATH") {
        // Custom ImageCellWithPreview component for hover preview

        return {
          ...baseColumn,
          headerName: "Image",
          minWidth: 120,
          flex: 0,
          sortable: false,
          filterable: false,
          renderCell: (params) => <ImageCellWithPreview value={params.value} />,
        };
      }
      if (key === "Ptype") {
        return {
          ...baseColumn,
          renderCell: (params) => {
            const ptype = String(params.value || "")
              .trim()
              .toUpperCase();

            let label = "";
            let color = "";

            switch (ptype) {
              case "IMPORT":
                label = "IMPORT";
                color = "#2563eb"; // blue
                break;

              case "LOCAL":
                label = "LOCAL";
                color = "#16a34a"; // green
                break;

              default:
                label = ptype || "UNKNOWN";
                color = "#6b7280"; // gray
            }

            return (
              <div
                style={{
                  fontSize: "0.75rem",
                  fontWeight: "600",
                  color,
                }}
              >
                {label}
              </div>
            );
          },
        };
      }
      // console.log("baseColumn", baseColumn);
      return baseColumn;
    });
}

export function generateRowsWithIds(rows) {
  return rows.map((row) => ({
    ...row,
    id: crypto.randomUUID(),
  }));
}

export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // format: YYYY-MM-DD
};
